import { RootState } from '../../interfaces'

export const getAttributeUpdateErrors = (state: RootState) => state.dsrForm.attributeUpdateErrors
